export default class Controller {
	/**
	 * A Controller class from which many other classes inherit...
	 * Any key-value pairs on `attributes` will be transferred to the instance.
	 * @param {Object} options
	 * @param {*} options.model
	 * @param {*} options.collection
	 * @param {Object} options.attributes
	 */
	constructor(options) {
		this.model = undefined;
		this.collection = undefined;
		this._id = _.uniqueId("t");

		if (_.isObject(options)) {
			if (options.model) {
				this.model = options.model;
			}
			if (options.collection) {
				this.collection = options.collection;
			}
			if (_.isObject(options.attributes)) {
				_.extend(this, options.attributes);
			}
			this.options = _.omit(options, ["model", "attributes", "collection"]);
		}
	}
}
